import { createApp } from 'vue';
import VueDataObjectPath from 'vue-data-object-path';
import FontAwesomeIcon from '@/lib/font-awesome';
import App from './App.vue';

createApp(App)
  .use(VueDataObjectPath)
  .component('fa', FontAwesomeIcon)
  .mount('#app');
